"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.todayOf = exports.spin = exports.remainingStock = exports.pickPrize = exports.parseConfig = exports.newId = exports.hourWeight = exports.emptyState = exports.effectiveGiven = exports.decide = exports.dateKey = exports.angleFor = exports.DEFAULT_CONFIG = void 0;
// Prize logic of the "Roue 2" cell. Pure functions (no DOM, no network, no Date.now) so they can be
// checked in node and so the wheel decides on the device itself, with or without internet.
//
// Two draw modes:
//  - 'quota'  : port of the Salon Habitat wheel (daily quota = remaining stock / remaining days,
//               spread over the hours by weight, win probability adapted to the recent traffic);
//  - 'random' : each spin wins with `winRate` %, the prize is picked among those still in stock.

var DEFAULT_CONFIG = exports.DEFAULT_CONFIG = {
  mode: 'quota',
  // quota | random
  winRate: 30,
  // random mode: % of spins that win
  useSchedule: true,
  // random mode: only play on the opening days/hours below
  code: '',
  // empty = no code to launch
  paused: false,
  testMode: false,
  // schedule ignored, separate counters, real stock untouched
  stockVersion: 1,
  // bump to wipe all counters (new event / new stock)
  shareStock: true,
  // deduct what the other devices gave (needs network from time to time)
  days: [],
  peak: {
    start: 13,
    end: 16,
    weight: 2.5
  },
  rate: 0.5,
  rateWindowMinutes: 20,
  slotCarryCap: 1.5,
  segments: [],
  // prize key or null per segment, clockwise from the top
  segmentOffset: 0,
  // degrees between the pointer and the centre of the 1st segment
  segmentStyles: [],
  // per segment overrides: {label, bg, text, image_uri} (drawn wheel only)
  wheel: {
    // look of the wheel when source = 'generated' (drawn from this config, no image needed)
    source: 'image',
    // image | generated
    colors: [{
      bg: '#c20e1a',
      text: '#ffffff'
    }, {
      bg: '#ffffff',
      text: '#c20e1a'
    }],
    // cycled over the segments
    separatorWidth: 3,
    separatorColor: '#ffffff',
    borderWidth: 18,
    borderColor: '#c20e1a',
    hub: {
      show: true,
      size: 120,
      color: '#c20e1a',
      image_uri: ''
    },
    fontFamily: '',
    // empty = font of the page
    fontSize: 46,
    fontWeight: 'bold',
    textRadius: 62,
    // % of the radius where the text is centred
    textDirection: 'outward',
    // outward | inward
    showLabels: true,
    loseLabel: 'Perdu',
    imageSize: 120,
    imageRadius: 72
  },
  prizes: {},
  // key -> {label, partner, stock, weight, image_uri, logo_uris}
  stage: {
    width: 1080,
    height: 1920
  },
  layout: {
    title: {
      show: true,
      x: 310,
      y: 283,
      w: 460,
      h: 104,
      size: 38,
      color: '#ffffff'
    },
    wheel: {
      x: 0,
      y: 375,
      size: 1080
    },
    arrow: {
      show: true,
      x: 485,
      y: 418,
      size: 110
    },
    form: {
      x: 170,
      y: 590,
      w: 740
    },
    timer: {
      y: 715,
      size: 340
    },
    result: {
      x: 90,
      y: 440,
      w: 900
    }
  },
  options: {
    idleSpin: false,
    // the wheel turns slowly while waiting for a player
    idleSpinSeconds: 10,
    countdown: true,
    // 3-2-1-GO before the spin
    sound: true,
    spinSeconds: 17,
    showResult: true,
    resultSeconds: 15,
    panelBackground: '#ffffff'
  },
  form: {
    // optional player form (data is stored with the play and synced)
    enabled: false,
    title: 'Vos informations',
    fields: [] // {name, label, type: text|email|tel|number|select|checkbox, required, options: []}
  },
  texts: {
    launch: 'Lancer la roue',
    admin: 'Gestion des stocks',
    confirm: 'Confirmer',
    play: 'Jouer',
    codeLabel: 'Code',
    wrongCode: 'Code incorrect.',
    needCode: 'Entrez le code.',
    missingFields: 'Veuillez remplir tous les champs.',
    paused: 'La roue est momentanément indisponible.',
    notConfigured: "La roue n'est pas configurée.",
    win: 'Félicitations !',
    lose: 'Dommage !',
    loseSub: "Ce n'est pas gagné cette fois.",
    thanks: "Merci d'avoir participé."
  }
};
var isPlainObject = function isPlainObject(v) {
  return v && typeof v === 'object' && !Array.isArray(v);
};

// Nested objects (layout, options, texts...) are merged key by key so an older saved config keeps
// working when new options appear; arrays and prizes are taken as saved.
var _deepMerge = function deepMerge(base, over) {
  var out = _objectSpread({}, base);
  for (var _i = 0, _Object$keys = Object.keys(over || {}); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var keepAsSaved = k === 'prizes' || k === 'segments' || k === 'days' || k === 'fields' || k === 'segmentStyles';
    out[k] = !keepAsSaved && isPlainObject(base[k]) && isPlainObject(over[k]) ? _deepMerge(base[k], over[k]) : over[k];
  }
  return out;
};
var parseConfig = function parseConfig(raw) {
  var parsed = {};
  try {
    parsed = typeof raw === 'string' ? JSON.parse(raw || '{}') : raw || {};
  } catch (e) {
    parsed = {};
  }
  return _deepMerge(DEFAULT_CONFIG, parsed);
};
exports.parseConfig = parseConfig;
var emptyState = function emptyState() {
  return {
    given: {},
    spins: [],
    days: {},
    events: [],
    pending: [],
    server: null
  };
};

// RFC4122 v4 id generated on the device, so a retried sync never counts a play twice.
exports.emptyState = emptyState;
var newId = function newId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.floor(Math.random() * 16);
    return (c === 'x' ? r : r & 3 | 8).toString(16);
  });
};
exports.newId = newId;
var pad = function pad(n) {
  return String(n).padStart(2, '0');
};
var dateKey = function dateKey(d) {
  return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()));
};
exports.dateKey = dateKey;
var toMin = function toMin(hhmm) {
  var _String$split$map = String(hhmm).split(':').map(Number),
    _String$split$map2 = _slicedToArray(_String$split$map, 2),
    h = _String$split$map2[0],
    m = _String$split$map2[1];
  return h * 60 + (m || 0);
};
var hourWeight = function hourWeight(config, h) {
  var p = config.peak;
  return p && h >= Number(p.start) && h < Number(p.end) && Number(p.weight) > 0 ? Number(p.weight) : 1;
};

// Prizes given so far = the larger of what this device counted and what the server knows
// (other devices' plays + this device's plays not yet synced).
exports.hourWeight = hourWeight;
var effectiveGiven = function effectiveGiven(config, state) {
  var out = {};
  var pendingCount = {};
  var _iterator = _createForOfIteratorHelper(state.pending || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      if (!p.test && p.prize) pendingCount[p.prize] = (pendingCount[p.prize] || 0) + 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var server = config.shareStock && state.server && state.server.version === config.stockVersion ? state.server.counts : {};
  for (var _i2 = 0, _Object$keys2 = Object.keys(config.prizes); _i2 < _Object$keys2.length; _i2++) {
    var k = _Object$keys2[_i2];
    out[k] = Math.max(state.given[k] || 0, (server[k] || 0) + (pendingCount[k] || 0));
  }
  return out;
};
exports.effectiveGiven = effectiveGiven;
var remainingStock = function remainingStock(config, state) {
  var given = effectiveGiven(config, state);
  var r = {};
  for (var _i3 = 0, _Object$keys3 = Object.keys(config.prizes); _i3 < _Object$keys3.length; _i3++) {
    var k = _Object$keys3[_i3];
    r[k] = (Number(config.prizes[k].stock) || 0) - given[k];
  }
  return r;
};
exports.remainingStock = remainingStock;
var pickPrize = function pickPrize(config, stock, rand) {
  var entries = Object.entries(stock).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      n = _ref2[1];
    return n > 0;
  });
  var weightOf = function weightOf(k, n) {
    return Number(config.prizes[k] && config.prizes[k].weight) > 0 ? Number(config.prizes[k].weight) : n;
  };
  var total = entries.reduce(function (a, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      k = _ref4[0],
      n = _ref4[1];
    return a + weightOf(k, n);
  }, 0);
  var r = rand() * total;
  var _iterator2 = _createForOfIteratorHelper(entries),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        k = _step2$value[0],
        n = _step2$value[1];
      r -= weightOf(k, n);
      if (r < 0) return k;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return entries.length ? entries[entries.length - 1][0] : null;
};

// Opening day of `now`; in test mode every day is open all day.
exports.pickPrize = pickPrize;
var todayOf = function todayOf(config, now) {
  var d = dateKey(now);
  var idx = config.days.findIndex(function (day) {
    return day.date === d;
  });
  if (idx >= 0) return _objectSpread(_objectSpread({}, config.days[idx]), {}, {
    index: idx
  });
  if (config.testMode) return {
    date: d,
    open: '00:00',
    close: '24:00',
    index: 0
  };
  return null;
};
exports.todayOf = todayOf;
var decideRandom = function decideRandom(config, state, now, rand) {
  if (config.useSchedule && config.days.length) {
    var day = todayOf(config, now);
    if (!day) return null;
    var nowMin = now.getHours() * 60 + now.getMinutes();
    if (nowMin < toMin(day.open) || nowMin >= toMin(day.close)) return null;
  }
  var stock = remainingStock(config, state);
  if (rand() * 100 >= Number(config.winRate)) return null;
  return pickPrize(config, stock, rand);
};
var decideQuota = function decideQuota(config, state, now, rand) {
  var day = todayOf(config, now);
  if (!day) return null;
  var stock = remainingStock(config, state);
  var left = Object.values(stock).reduce(function (a, n) {
    return a + Math.max(n, 0);
  }, 0);
  if (left <= 0) return null;
  if (!state.days[day.date]) state.days[day.date] = {
    won: 0,
    startStock: left
  };
  var ds = state.days[day.date];
  var daysLeft = config.testMode ? 1 : Math.max(config.days.length - day.index, 1);
  var dayQuota = Math.ceil(ds.startStock / daysLeft);
  var open = toMin(day.open),
    close = toMin(day.close);
  var hour = now.getHours();
  var nowMin = hour * 60 + now.getMinutes() + now.getSeconds() / 60;
  if (nowMin < open || nowMin >= close) return null;
  var totalW = 0,
    upTo = 0;
  for (var h = Math.floor(open / 60); h * 60 < close; h++) {
    totalW += hourWeight(config, h);
    if (h <= hour) upTo += hourWeight(config, h);
  }
  var slotQuota = dayQuota * hourWeight(config, hour) / totalW;
  var target = dayQuota * upTo / totalW;
  var budget = Math.min(target - ds.won, slotQuota * config.slotCarryCap);
  if (budget <= 0) return null;
  var slotEnd = Math.min((hour + 1) * 60, close);
  var minLeft = Math.max(slotEnd - nowMin, 0.5);
  var since = now.getTime() - config.rateWindowMinutes * 60000;
  var recent = state.spins.filter(function (t) {
    return t > since;
  }).length;
  var rate = Math.max(recent / config.rateWindowMinutes, Number(config.rate) || 0.5);
  var isLast = slotEnd === close;
  var p = isLast && minLeft < 10 ? 1 : Math.min(1, budget / (rate * minLeft));
  if (rand() >= p) return null;
  return pickPrize(config, stock, rand);
};

// Returns the prize key, or null (lost).
var decide = function decide(config, state, now, rand) {
  return (config.mode === 'random' ? decideRandom : decideQuota)(config, state, now, rand);
};

// Total rotation (degrees) that stops the pointer (top) on a segment showing `prize` (null = a losing one).
exports.decide = decide;
var angleFor = function angleFor(config, prize, rand) {
  var n = config.segments.length || 1;
  var seg = 360 / n;
  var candidates = [];
  config.segments.forEach(function (p, i) {
    if ((p || null) === (prize || null)) candidates.push(i);
  });
  if (!candidates.length) candidates = config.segments.map(function (_, i) {
    return i;
  });
  if (!candidates.length) candidates = [0];
  var center = candidates[Math.floor(rand() * candidates.length)] * seg + (Number(config.segmentOffset) || 0);
  var jitter = (rand() * 2 - 1) * Math.max(seg / 2 - 8, 1);
  var turns = 10 + Math.floor(rand() * 4);
  return turns * 360 + ((360 - center) % 360 + 360) % 360 + jitter;
};

// Runs one spin: decides, updates the counters, queues the play for syncing and returns what the UI needs.
exports.angleFor = angleFor;
var spin = function spin(config, state, now, rand) {
  var player = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var day = todayOf(config, now);
  var prize = decide(config, state, now, rand);
  if (prize) {
    state.given[prize] = (state.given[prize] || 0) + 1;
    if (day && state.days[day.date]) state.days[day.date].won++;
  }
  var t = now.getTime();
  state.spins = state.spins.filter(function (x) {
    return x > t - 3600000;
  });
  state.spins.push(t);
  state.events.push({
    t: t,
    prize: prize
  });
  if (state.events.length > 2000) state.events = state.events.slice(-2000);
  var play = {
    id: newId(),
    t: t,
    prize: prize,
    player: player,
    stock_version: config.stockVersion,
    test: !!config.testMode
  };
  state.pending = (state.pending || []).concat(play);
  return {
    prize: prize,
    angle: angleFor(config, prize, rand),
    play: play
  };
};
exports.spin = spin;